import { Component, Input, OnInit, inject, signal } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { finalize } from "rxjs";
import { UserRegisterModel } from "src/app/models/user-register.model";
import { AlertHelper } from "src/app/helper/alert.helper";
import { AuthService } from "src/app/services/auth.service";
import { LoginComponent } from "../form-login/login.component";

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"],
  imports: [ReactiveFormsModule],
})
export class RegisterComponent implements OnInit {
  private static readonly DEFAULT_CHANNEL = { numericId: 1, id: "0" } as const;
  private static readonly DEFAULT_ROLE = 0;

  // Injections
  private alert = inject(AlertHelper);
  private auth = inject(AuthService);
  private formBuilder = inject(FormBuilder);
  private modalService = inject(NgbModal);

  @Input() modal!: NgbModalRef;

  loading = signal(false);
  hidePass = signal(true);
  hideConfirmPass = signal(true);

  registerForm!: FormGroup;

  ngOnInit(): void {
    this.registerForm = this.formBuilder.group(
      {
        name: ["", Validators.required],
        email: ["", [Validators.required, Validators.email]],
        phone: ["", [Validators.required, Validators.pattern(/^[0-9]+$/)]], // Validasi angka
        idtype: ["NIK", Validators.required],
        identity: ["", Validators.required],
        birthDate: ["", Validators.required],
        password: ["", [Validators.required, Validators.minLength(6)]],
        confirmPassword: ["", Validators.required],
      },
      { validators: this.passwordMatchValidator }
    );
  }

  get f() {
    return this.registerForm.controls;
  }

  passwordMatchValidator: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const pass = control.get("password")?.value;
    const confirmPass = control.get("confirmPassword")?.value;
    return pass === confirmPass ? null : { mismatch: true };
  };

  togglePass() {
    this.hidePass.update((v) => !v);
  }

  toggleConfirmPass() {
    this.hideConfirmPass.update((v) => !v);
  }

  register() {
    if (this.registerForm.invalid) {
      this.registerForm.markAllAsTouched();
      return;
    }

    function normalizePhone(phone: string): string {
      let normalized = phone.trim().replace(/\s+/g, "").replace(/^\+/, "");
      normalized = normalized.replace(/^(62|0)/, "");
      return normalized;
    }

    this.loading.set(true);
    const raw = this.registerForm.getRawValue();

    // Payload Construct
    const payload: UserRegisterModel = {
      userId: {
        mailaddr: raw.email,
        channel: RegisterComponent.DEFAULT_CHANNEL,
      },
      birthDate: raw.birthDate,
      id: raw.identity,
      categoryOrIdtype: raw.idtype,
      name: raw.name,
      organization: "asah-skill",
      password: raw.password,
      phone: normalizePhone(raw.phone),
      rolename: RegisterComponent.DEFAULT_ROLE,
    };

    this.auth
      .registerAsync(payload)
      .pipe(finalize(() => this.loading.set(false)))
      .subscribe({
        next: () => {
          this.alert.success(
            "Berhasil",
            "Registrasi berhasil! Silakan Check email anda."
          );
          this.modal.close();
        },
        error: (err) => {
          console.error(err);
          this.alert.error(
            "Gagal",
            err.error?.message || "Gagal melakukan registrasi."
          );
        },
      });
  }

  openLoginModal() {
    this.modal.close();
    const modalRef = this.modalService.open(LoginComponent, {
      centered: true,
    });
    modalRef.componentInstance.modal = modalRef;
  }
}
